module.exports = __webpack_public_path__ + "img/clap.0f623a03.png";